import { Button, cn } from '@landler/component-library';
import { useTranslation } from 'react-i18next';

import { useControlsContext } from './hooks/useFormControls';
import { DEFAULT_MAP_LAYER_FILTER, SetMapLayerFilter } from './hooks/useMapLayerFilter';

export const ClearLayersButton = ({ setLegendFilter }: { setLegendFilter?: SetMapLayerFilter }) => {
  const { t } = useTranslation();
  const controlsForm = useControlsContext();
  const layers = controlsForm.watch('layers');
  const hasSelectedLayers = layers && layers.length > 0;

  const clearLayers = () => {
    if (!hasSelectedLayers) {
      return;
    }
    setLegendFilter?.(DEFAULT_MAP_LAYER_FILTER);
    controlsForm.setValue('layers', []);
    controlsForm.setValue('habitatIntactnessThreats', []);
  };

  return (
    <Button
      disabled={!hasSelectedLayers}
      className={cn('w-fit', !hasSelectedLayers && 'cursor-not-allowed opacity-40 hover:bg-transparent')}
      onClick={clearLayers}
      data-testid='clear-map-layers'
      variant='text'
      size='small'
    >
      {t('shared.projects.project.clearHeatMapLayers')}
    </Button>
  );
};
